import { ILot } from '../../lot';
import { IRfq } from '../../rfq';
import { IUnitOfMeasure } from '../../unit-of-measure';

import {
  IDimension,
  IWeight,
  OptionInterface,
} from './../../shared/interfaces/common.interface';

export interface PickListInterface {
  id :number;
  createdAt :Date;
  updatedAt :number;
  itemCount :number;
  items :PickListItemInterface[];
  status :PicklistStatus;
  totalUnits :number;
  orderNumbers ?:{
    laravel_through_key :number;
    orderNumber :string;
  }[];
  orders ?:PicklistOrderInterface[];
}

export interface PickListLocationInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  deletedAt :string;
  createdBy :number;
  updatedBy :number;
  deletedBy :number;
  status :string;
  locationName :string;
  parentId :number;
  address :string;
  country :string;
  zip :string;
  state :string;
  city :string;
  streetAddress1 :string;
  streetAddress2 :string;
  meta :string;
  parent ?:PickListLocationInterface;
  rfqStockLocations ?:IPickListRfqStockLocation[];
}

export interface IPickListRfqStockLocation {
  id :number;
  locationId :number;
  lotId :number;
  onHandQuantity :number;
  reservedQuantity :number;
  rfqId :number;
  rfqStockId :number;
  status :string;
}

export interface PickListOrderInterface {
  id :number;
  orderDate :Date;
  source :string;
  orderNumber :string;
  orderTotal :number;
}

export interface PickListOrderItemInterface {
  mtShipstationOrderId :number;
  orderItemId :number;
  lineItemKey :string;
  sku :string;
  name :string;
  imageUrl :string;
  weight :string;
  quantity :number;
  unitPrice :number;
  taxAmount :number;
  shippingAmount :0;
  warehouseLocation :any;
  options :any;
  productId :4;
  fulfillmentSku :any;
  adjustment :any;
  upc :any;
  createDate :Date;
  modifyDate :Date;
  orderDate :Date;
  paymentDate :Date;
  orderStatus :string;
  stockId :number;
  kitId :number;
  rfqId :number;
  nonPhysicalItem :false;
  ignoreItem :false;
  quantityShipped :number;
  quantityCancelled :number;
  orderedUomId :number;
  baseUomId :number;
  orderedQty :number;
  baseUom :IUnitOfMeasure;
  orderedUom :IUnitOfMeasure;
  orderedQuantity :number;
}

export interface PickListItemInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  locationId :number | null;
  rfqId :number;
  lotId :number | null;
  orderItem :PickListOrderItemInterface;
  availableQuantity :number; // AVAILABLE QUANTITY
  picked :boolean;
  order :PickListOrderInterface;
  rfq :any;
  location :PickListLocationInterface | null;
  lot :ILot | null;
  parentId :number;
  pickedQuantity :number;
  status :any;
  checked ?:boolean;
  savedAt :Date | null;
  picklistId :number;
}

export interface PicklistItemUiInterface {
  availableQuantity :number;
  baseUom :string;
  id :number;
  warehouseId :number | undefined;
  locationId :number | null;
  lotId :number | null;
  lotTracking :boolean;
  orderDate :Date;
  parentId :number | null;
  pickedQuantity :number;
  productDescription :string;
  productName :string;
  internalSku :string;
  rfqId :number;
  rfqPhoto :string;
  selectedLocation :OptionInterface | null;
  selectedLot :OptionInterface | null;
  status :PickListItemStatus[];
  tempId :number | null;
  updatedAt :Date;
  checked ?:boolean;
  isUpdated ?:boolean;
}

// FOR PICKLIST ITEM TABLE
export interface PickListItemTableInterface extends PickListItemInterface {
  pickedQuantity :number;
  // status: PickListItemStatus[];
  selectedLocation :OptionInterface | null;
  selectedLot :OptionInterface | null;
  tempId :number | null;
}

export interface PickListItemDraftInterface {
  id :number;
  tempId :number | null;
  status :PickListItemStatus[];
  pickedQuantity :number;
  availableQuantity :number;
  locationId :number | null;
  lotId :number | null;
  parentId :number | null;
  locationName ?:string;
  lotNumber ?:string;
  warehouseId :number | undefined;
  rfqId :number;
}

export enum PicklistStatus {
  CREATED = 'CREATED',
  PICKED = 'PICKED',
  SHIPPED = 'SHIPPED',
  PICKING = 'PICKING',
  PACKED = 'PACKED',
}

export enum PickListItemStatus {
  UNPICKED = 'Unpicked',
  IN_PROGRESS = 'In Progress',
  PICKED = 'Picked',
  SPLIT = 'Split',
  SHIPPED = 'SHIPPED',
  DISABLED = 'Disabled',
}

export enum PicklistSalesOrderStatus {
  SHIPPED = 'shipped',
  ON_HOLD = 'on_hold',
  CANCELLED = 'cancelled',
  AWAITING_SHIPMENT = 'awaiting_shipment',
  PARTIALLY_SHIPPED = 'partially_shipped',
  PENDING = 'pending',
}

export interface PicklistPreviewItemInterface {
  id :number;
  orderDate :string;
  orderNumber :number;
  pickingItems :PreviewPickingItemInterface[];
  fulfillmentStatus :boolean;
}

export interface PreviewPickingItemInterface {
  rfq :PreviewPickingRfqItemInterface;
  location :PreviewPickingLocationItemInterface;
  lot :PreviewPickingLotItemInterface;
  pickedQuantity :number;
  availableQuantity :number;
  orderedQuantity ?:number;
}

export interface PreviewPickingRfqItemInterface {
  internal_sku :string;
  product_name :string;
}

export interface PreviewPickingLocationItemInterface {
  location_name :string;
}

export interface PreviewPickingLotItemInterface {
  lot_number :string;
}

export interface PicklistOrderInterface {
  id :number;
  orderNumber :string;
  orderDate :Date;
  orderStatus :string;
  orderItems :PicklistOrderItemInterface[];
  shipDate :Date;
  shipTo :string;
  billTo :string;
  shipments ?:IPicklistOrderShipment[];
  source :string;
  shipstationOrderId :number;
  channelId :number;
  carrierCode :string;
  serviceCode :string;
  packageCode :string;
  weight :IWeight;
  dimensions :IDimension;
  confirmation :string;
  destinationAppIntegrationAccountId :number;
}

export interface PicklistOrderItemInterface {
  id :number;
  rfqId :number;
  createDate :Date;
  rfq :IRfq;
  orderedQty :number;
}

export interface IPicklistOrderShipment {
  id :number;
  salesOrderId :number;
  labelData :string;
}

export interface IPicklistOrderItems {
  id :number;
  created_at :string;
  updated_at :string;
  mt_shipstation_order_id :number;
  orderItemId :number;
  lineItemKey :string;
  sku :string;
  name :string;
  imageUrl ?:any;
  weight ?:any;
  quantity :number;
  unitPrice :number;
  taxAmount ?:any;
  shippingAmount ?:any;
  warehouseLocation ?:any;
  options ?:any;
  productId :number;
  fulfillmentSku ?:any;
  adjustment ?:any;
  upc ?:any;
  createDate :string;
  modifyDate :string;
  orderDate :string;
  paymentDate ?:any;
  orderStatus :string;
  stock_id :number;
  kit_id :number;
  rfq_id :number;
  non_physical_item :number;
  ignore_item :number;
  quantity_shipped :number;
  quantity_cancelled :number;
  ordered_qty :number;
  base_uom_id :number;
  ordered_uom_id :number;
  shipping_revenue_percentage :number;
  cost :number;
  discount :number;
  total_returned_base_quantity :number;
  parent_id ?:any;
  internal_resource_item_id ?:any;
  internal_resource_item_type ?:any;
  pickingLocation ?:string;
  pickingWarehouse ?:string;
  rfq :IRfqKit;
}

interface IRfqKit {
  id :number;
  internal_sku :string;
  product_name :string;
  product_description :string;
  type :string;
  total_variant_skus :number;
  kit_items :any[];
}

export enum EPicklistOderStatus {
  PENDING = 'pending',
  SHIPPED = 'shipped',
  CANCELLED = 'cancelled',
  AWAITING_SHIPMENT = 'awaiting_shipment',
  PARTIALLY_SHIPPED = 'partially_shipped',
  ON_HOLD = 'on_hold',
}

export enum EPicklistOrderSource {
  LUMINOUS = 'luminous',
  SHIPSTATION = 'shipstation',
}

export enum EPicklistPackingTableColSpan {
  DEFAULT = 8,
  QUICK_FULFILLMENT_ENABLED = 9,
}
